export default __webpack_public_path__ + "static/media/githubLogo.d34c3995.svg";